import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomDataset,
  BackendMutationPerformanceCenterRecreateCustomModelArgs,
} from 'src/types/backend';

import { CUSTOM_DATASET_FRAGMENT } from '../customModel/schema';

const MUTATION = gql`
  mutation PerformanceCenterRecreateCustomModel(
    $customModelId: ID!
    $accountId: ID
    $dataSource: PerformanceCenterDataSource
  ) {
    performanceCenterRecreateCustomModel(
      customModelId: $customModelId
      accountId: $accountId
      dataSource: $dataSource
    ) {
      ...CustomDataset
    }
  }
  ${CUSTOM_DATASET_FRAGMENT}
`;

type Variables = BackendMutationPerformanceCenterRecreateCustomModelArgs;
type Result = BackendCustomDataset;

export const performanceCenterRecreateCustomModel = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
